const FailurePaidOrExpired = () => import("../components/pages/reservation/FailurePaidOrExpired.vue");

export default [
    { path: "/", component: () => import("../components/pages/AvailableTerms.vue"), alias: "/rezervace" },
    { path: "/rezervace-pobocka/:branch", component: () => import("../components/pages/AvailableTerms.vue") },
    { name: "Login", path: "/login/:returnpath", component: () => import("../components/pages/LoginPage.vue") },
    { path: "/login", component: () => import("../components/pages/LoginPage.vue") },
    { name: "Register", path: "/register/:returnpath", component: () => import("../components/pages/RegisterPage.vue") },
    { path: "/register", component: () => import("../components/pages/RegisterPage.vue") },
    { path: "/my-profile", component: () => import("../components/pages/MyProfile.vue") },
    { path: "/reservation", component: () => import("../components/pages/TermsReservation.vue") },
    { path: "/edit-profile", component: () => import("../components/pages/EditDetails.vue") },
    { path: "/registration-finished", component: () => import("../components/pages/RegistrationFinished.vue") },
    { path: "/reservation/failure/:id", component: () => import("../components/pages/reservation/FailureReservation.vue") },
    {
        path: "/reservation/failure/paid-or-expired",
        component: FailurePaidOrExpired,
    },
    { path: "/reservation/success/:id", component: () => import("../components/pages/reservation/SuccessReservation.vue") },
    { path: "/transaction/failure/:id", component: () => import("../components/pages/transaction/FailureTransaction.vue") },
    {
        path: "/transaction/failure/paid-or-expired",
        component: FailurePaidOrExpired,
    },
    { path: "/transaction/success/:id", component: () => import("../components/pages/transaction/SuccessTransaction.vue") },
    { path: "/payment/cancel", component: () => import("../components/pages/PaymentCancel.vue") },
    { path: "/forgot-password", component: () => import("../components/pages/ForgotPassword.vue") },
    { path: "/password-reset/:token", component: () => import("../components/pages/NewPassword.vue") },
    { path: "/verify-email/:id/:hash", component: () => import("../components/pages/VerifyEmail.vue") },
    { path: "/verify-email/success", component: () => import("../components/pages/registration/RegistrationSuccess.vue") },
    { path: "/verify-email/failure", component: () => import("../components/pages/registration/RegistrationFailure.vue") },
    {
        path: "/new-password/success",
        component: () => import("../components/pages/NewPasswordSuccess.vue"),
        name: "NewPasswordSuccess",
    },
];
